import { USER_UPDATE_TWITCH } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { gatewayEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'

export default {
	[USER_UPDATE_TWITCH]: {
		endpointType: gatewayEndpointType,
	},
}
